export const cryptoBasics = [
  {
    id: "cb-1",
    title: "What is Lorem Ipsum?",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    imgPath: "assets/images/basic1.jpg",
  },
  {
    id: "cb-2",
    title: "Why do we use it?",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum",
    imgPath: "assets/images/basic2.jpg",
  },
];

export const tipsTutorials = [
  {
    id: "tt-1",
    title: "Where does it come from?",
    description:
      "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia",
    imgPath: "assets/images/tips1.jpg",
  },
  {
    id: "tt-2",
    title: "Where can I get some?",
    description:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour",
    imgPath: "assets/images/tips2.jpg",
  },
];
